enum AnalyticsEvent {
  PageView = 'page_view',
  ConfirmClicked = 'confirm_clicked',
  ConfirmCompleted = 'confirm_completed',
  ConfirmFailed = 'confirm_failed',
  EditStarted = 'edit_started',
  EditSaved = 'edit_saved',
  FiltersChanged = 'filters_changed',
  SortChanged = 'sort_changed',
  PlanningViewLoaded = 'planning_view_loaded',
  ViewLoadFailed = 'view_load_failed',
}

export default AnalyticsEvent;
